module.exports = __webpack_public_path__ + "static/media/image71.e23d6774.JPG";